import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixInnovationAssistantWidgetV1ConversationsUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/wix-assistant-widget',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/wix-assistant-widget',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/wix-assistant-widget',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/wix-assistant-widget',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/wix-assistant-widget',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/wix-assistant-widget',
        destPath: '',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/wix-assistant-widget',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/wix-assistant-widget',
        destPath: '',
      },
      {
        srcPath: '/innovation/widget',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/wix-assistant-widget',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_ai-site-chat_conversations';

/**
 * Retrieves the conversation for the site visitor calling this method.
 *
 * This method must be called using the site visitor or site member identity ([SDK](https://dev.wix.com/docs/sdk/articles/get-started/about-identities#site-member) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/about-identities#site-member)) to identify the site visitor that is requesting the conversation.
 */
export function getConversation(payload: object): RequestOptionsFactory<any> {
  function __getConversation({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.innovation.widget.v1.conversation',
      method: 'GET' as any,
      methodFqn:
        'wix.innovation.assistant.widget.v1.Conversations.GetConversation',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixInnovationAssistantWidgetV1ConversationsUrl({
        protoPath: '/v1/conversation',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'conversation.createdDate' },
              { path: 'conversation.updatedDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getConversation;
}
